var map = {
	"./1___MG_1535.webp": "./src/img/brands/bacardi/1___MG_1535.webp",
	"./Felicitas_Ernst_Advertising_BacardiBACARDI _ DIA 10375.webp": "./src/img/brands/bacardi/Felicitas_Ernst_Advertising_BacardiBACARDI _ DIA 10375.webp",
	"./Felicitas_Ernst_Advertising_BacardiBACARDI_DIA 20693.webp": "./src/img/brands/bacardi/Felicitas_Ernst_Advertising_BacardiBACARDI_DIA 20693.webp",
	"./Felicitas_Ernst_Advertising_BacardiFoto 1_Bacardi.webp": "./src/img/brands/bacardi/Felicitas_Ernst_Advertising_BacardiFoto 1_Bacardi.webp",
	"./_MG_1529.webp": "./src/img/brands/bacardi/_MG_1529.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/bacardi sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";